import * as variables from './variables.js';

/* Polyfills
------------ */
import './polyfill/matches';
import './polyfill/closest';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import './component/menu.service';

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import Forms from './component/Forms';
Forms.init();

import Gallery from './component/Gallery';
new Gallery();

import InitVideoPlayer from './component/VideoMasthead';
const initVideoPlayer = new InitVideoPlayer();

// @ts-ignore
var Accordion = require('./component/EventListing.js');
var filtersAccordion = new Accordion({
	scope: '.__events'
});
filtersAccordion.activate();

// @ts-ignore
import * as AnchorLinkSmoothScroll from './component/AnchorLinkSmoothScroll.js';
AnchorLinkSmoothScroll.init();

/* Modals */
import NewsletterSignup from './component/NewsletterSignup';
NewsletterSignup();

import EstablishmentModal from './component/EstablishmentModal';
EstablishmentModal();

import ExpandableAreaModal from './component/ExpandableAreaModal';
ExpandableAreaModal();

import VenueMapController from './component/VenueMapController';
VenueMapController();
